module.exports = __webpack_public_path__ + "static/media/jama_ravi.033d181b.png";